import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { useBoolean } from "@miplatform/hooks";
import {
  ButtonVariants,
  Colors,
  IStep,
  StepDisplayConfigButtonType,
} from "@miplatform/types";
import { mdiContentCopy, mdiOpenInNew } from "@mdi/js";
import { Box, Typography } from "@mui/material";

export const WorkOrderDrawerGeneralStep = ({
  step,
}: WorkOrderDrawerGeneralStepProps) => {
  const [isCopied, turnIsCopiedOn, turnIsCopiedOff] = useBoolean();

  const { classes } = useStyles();

  const handleClick = () => {
    if (step.displayConfig.buttonType === StepDisplayConfigButtonType.Link) {
      const normalizeUrl = (url: string) => {
        if (!url) return "";

        if (url.startsWith("http://") || url.startsWith("https://")) return url;

        return `https://${url.replace(/^\/+/, "")}`;
      };

      window.open(
        normalizeUrl(step.displayConfig.content || ""),
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      navigator.clipboard
        .writeText(step.displayConfig.content || "")
        .then(() => {
          turnIsCopiedOff();
        });
      turnIsCopiedOn();
    }
  };

  return (
    <Box className={classes.section}>
      <Box display="flex" flexDirection="column">
        <Typography className={classes.title}>{step.title}</Typography>
        <Typography className={classes.description}>
          {step.description}
        </Typography>
      </Box>
      {step.displayConfig.hasButton && (
        <MiButton
          title={isCopied ? "Copied" : step.displayConfig.buttonLabel}
          startIcon={{
            path:
              step.displayConfig.buttonType === StepDisplayConfigButtonType.Link
                ? mdiOpenInNew
                : mdiContentCopy,
          }}
          color={isCopied ? Colors.Success : undefined}
          variant={ButtonVariants.Outlined}
          onClick={handleClick}
        />
      )}
    </Box>
  );
};

interface WorkOrderDrawerGeneralStepProps {
  step: IStep;
}

const useStyles = makeStyles()((theme) => ({
  section: {
    display: "flex",
    padding: theme.spacing(3),
    width: "100%",
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.grey.light,
    border: `1px solid ${theme.palette.grey.accent}`,
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    fontWeight: theme.fontWeight.semiBold,
  },
  description: {
    color: theme.palette.grey.dark,
    fontSize: theme.typography.pxToRem(14),
  },
}));
